import { Link } from 'gatsby';
import { Nav } from '../nav/nav';
import PropTypes from 'prop-types';
import React from 'react';

const Footer = ({ footerClassName }) => (
    <footer className={`site-footer${footerClassName && ' ' + footerClassName}`}>
        <div className="main-section dark">
            {/* <div className="w-container">
                <div className="columns-3 w-row">
                    <div className="column-19 w-col w-col-4">
                        <ul role="list" className="w-list-unstyled">
                            <li className="list-item-8">
                                <a href="https://www.dfes.wa.gov.au/aboutus/corporateinformation/Pages/default.aspx" className="w-inline-block">
                                    <div className="footer-text">About Us &gt;</div>
                                </a>
                                <a href="https://www.dfes.wa.gov.au/safetyinformation/Pages/default.aspx" className="w-inline-block">
                                    <div className="footer-text">Hazard Information &gt;</div>
                                </a>
                                <a href="https://www.dfes.wa.gov.au/volunteers/Pages/default.aspx" className="w-inline-block">
                                    <div className="footer-text">Volunteering &gt;</div>
                                </a>
                                <a
                                    href="https://www.dfes.wa.gov.au/regulationandcompliance/buildingplanassessment/Pages/default.aspx"
                                    className="w-inline-block"
                                >
                                    <div className="footer-text">Regulation &amp; Compliance &gt;</div>
                                </a>
                                <a href="https://www.dfes.wa.gov.au/waemergencyandriskmanagement/Pages/default.aspx" className="w-inline-block">
                                    <div className="footer-text">WA Emergency &amp; Risk Management &gt;</div>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="column-18 w-col w-col-4">
                        <ul role="list" className="list-2 w-list-unstyled">
                            <li className="list-item-8">
                                <a href="https://www.dfes.wa.gov.au/newsandmedia/Pages/NewsHome.aspx" className="w-inline-block">
                                    <div className="footer-text">News &amp; Media &gt;</div>
                                </a>
                                <a
                                    href="https://www.dfes.wa.gov.au/recruitmentandtraining/recruitment/Pages/careeropportunities.aspx"
                                    className="w-inline-block"
                                >
                                    <div className="footer-text">Recruitment &amp; Training &gt;</div>
                                </a>
                                <a href="https://www.dfes.wa.gov.au/schooleducation/Pages/default.aspx" className="w-inline-block">
                                    <div className="footer-text">School Education &gt;</div>
                                </a>
                                <a href="https://www.dfes.wa.gov.au/emergencyserviceslevy/Pages/default.aspx" className="w-inline-block">
                                    <div className="footer-text">Emergency Services Levy &gt;</div>
                                </a>
                                <a href="https://www.dfes.wa.gov.au/recovery/Pages/default.aspx" className="w-inline-block">
                                    <div className="footer-text">Recovery (WANDRRA/DRFA-WA) &gt;</div>
                                </a>
                            </li> 
                        </ul>
                    </div>
                    <div className="column-16 w-col w-col-4">
                        <div className="html-embed w-embed w-iframe">
                            <iframe
                                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fdfeswa&tabs=timeline&width=340&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false&appId"
                                width="340"
                                height="250"
                                scrolling="no"
                                frameBorder="0"
                                allowtransparency="true"
                                allow="encrypted-media"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="footer-section">
                <div className="w-container">
                    <div className="w-row">
                        <div className="column-8 w-col w-col-6 w-col-tiny-tiny-stack w-col-small-small-stack">
                            <a href="http://dfes.wa.gov.au/" className="w-inline-block" aria-label="Visit our website">
                                <img src="/annualreport2020/images/template/icon-dfes-black.png" alt="" />
                            </a>
                        </div>
                        <div className="column-7 w-col w-col-6 w-col-tiny-tiny-stack w-col-small-small-stack">
                            <a
                                href="https://www.facebook.com/dfeswa"
                                target="_blank"
                                className="w-inline-block"
                                aria-label="Visit our Facebook page"
                            >
                                <img
                                    src="/annualreport2020/images/template/icon-facebook-black_1icon-facebook-black.png"
                                    alt=""
                                    className="image-3"
                                />
                            </a>
                            <a
                                href="https://twitter.com/dfes_wa"
                                target="_blank"
                                className="w-inline-block"
                                aria-label="Visit our Twitter page"
                            >
                                <img
                                    src="/annualreport2020/images/template/icon-twitter-black_1icon-twitter-black.png"
                                    alt=""
                                    className="image-5"
                                />
                            </a>
                            <a
                                href="https://www.youtube.com/dfeswesternaustralia"
                                target="_blank"
                                className="w-inline-block"
                                aria-label="Visit our YouTube page"
                            >
                                <img
                                    src="/annualreport2020/images/template/icon-youtube-black_1icon-youtube-black.png"
                                    alt=""
                                    className="image-6"
                                />
                            </a>
                            <a
                                href="https://www.instagram.com/dfes_wa/"
                                target="_blank"
                                className="w-inline-block"
                                aria-label="Visit our Instagram page"
                            >
                                <img
                                    src="/annualreport2020/images/template/icon-instagram-black_1icon-instagram-black.png"
                                    alt=""
                                    className="image-4"
                                />
                            </a>
                            <a
                                href="https://www.linkedin.com/company/fire-&amp;-emergency-services-authority/"
                                target="_blank"
                                className="w-inline-block"
                                aria-label="Visit our LinkedIn page"
                            >
                                <img src="/annualreport2020/images/template/icon-linkedin-black_1icon-linkedin-black.png" alt="" />
                            </a>
                        </div>
                    </div>
                    <div className="columns-4 w-row">
                        <div className="column-17 w-col w-col-9">
                            <a href="http://wa.gov.au/" className="link-2" style={{ paddingRight: 0 }}>
                                WA.gov.au
                            </a>
                            <a href="https://www.dfes.wa.gov.au/pages/disclaimer.aspx" className="link-2">
                                Disclaimer
                            </a>
                            <a href="https://www.dfes.wa.gov.au/pages/privacy.aspx" className="link-3">
                                Privacy Policy
                            </a>
                            <a href="https://www.dfes.wa.gov.au/pages/foi.aspx" className="link-3">
                                Freedom of Information
                            </a>
                            <a href="https://www.dfes.wa.gov.au/pages/copyright.aspx" className="link-5">
                                Copyright
                            </a>
                            <a href="https://www.dfes.wa.gov.au/pages/accessibility.aspx" className="link-6">
                                Accessibility
                            </a>
                            <a href="https://www.dfes.wa.gov.au/contactus" className="link-7">
                                Contact Us
                            </a>
                        </div>
                        <div className="column-6 w-col w-col-3">
                            <div className="copyright-text">© Government of Western Australia. All rights reserved.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
